var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DraggableVirtualList", {
    staticClass: "activity-board-column flex-1 pt-2",
    attrs: {
      group: "kanban",
      "data-key": "id",
      "data-sources": _vm.columnActivities,
      "data-component": _vm.ItemComponent,
      "extra-props": { onSelect: _vm.onSelect },
      "estimate-size": 153,
      keeps: 30,
      sort: false,
      "ghost-class": "activity-ghost",
      handle: ".activity-handler"
    },
    model: {
      value: _vm.columnActivities,
      callback: function($$v) {
        _vm.columnActivities = $$v
      },
      expression: "columnActivities"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }